import { AbstractControl } from '@angular/forms';

export const UF = {
  default: 'UF_',
  hint: 'Solo se admiten mayúsculas y _',
  pattern: /^UF_[A-Z_]+$/,
} as const;

export function syncUfNameInput(e: Event, ctrl: AbstractControl | null): void {
  if (!ctrl || ctrl.disabled) return;
  const el = e.target as HTMLInputElement;
  const v = UF.default + el.value.replace(/^UF_?/i, '').toUpperCase().replace(/[^A-Z_]/g, '');
  if (el.value !== v) el.value = v;
  ctrl.setValue(v);
}

export function blockUfPrefixDelete(e: KeyboardEvent): void {
  const el = e.target as HTMLInputElement;
  if ((e.key === 'Backspace' || e.key === 'Delete') && (el.selectionStart ?? 0) <= 3) e.preventDefault();
}

export const ufFieldHandlers = { sync: syncUfNameInput, block: blockUfPrefixDelete };
